import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=151fcea4&scoped=true&"
import script from "./Step6.vue?vue&type=script&lang=js&"
export * from "./Step6.vue?vue&type=script&lang=js&"
import style0 from "./Step6.vue?vue&type=style&index=0&id=151fcea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fcea4",
  null
  
)

export default component.exports